const SenegalSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112300)">
      <path
        d="M28.6953 1.98453C26.066 0.713125 23.1161 0 19.9997 0C16.8833 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155C13.9335 39.2869 16.8833 40 19.9997 40C23.1161 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 13.043L21.7265 18.357H27.3146L22.794 21.6416L24.5206 26.9559L19.9999 23.6716L15.4792 26.9559L17.2062 21.6416L12.6855 18.357H18.2733L19.9999 13.043Z"
        fill="#496E2D"
      />
      <path
        d="M11.3044 1.98535C4.61453 5.22027 0 12.071 0 20.0001C0 27.9293 4.61453 34.78 11.3044 38.0149V1.98535Z"
        fill="#496E2D"
      />
      <path
        d="M28.6958 1.98535V38.0149C35.3856 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3856 5.22027 28.6958 1.98535Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112300">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SenegalSvg;
